<template>
  <div class="rowSectionForm">
    <ul class="rowSectionForm-params">
      <li>Высота: {{ data.height }}</li>
      <li>Глубина: {{ data.depth }}</li>
    </ul>
    <div class="rowSectionForm-fieldset">
      <div class="rowSectionForm-field">
        <label>Длина</label>
        <Select
          v-model="width"
          :options="options.width"
        />
      </div>
      <div class="rowSectionForm-field">
        <label>Кол-во полок</label>
        <Select
          v-model="count"
          :options="options.count"
        />
      </div>
      <button
        class="rowSectionForm-submit"
        @click="$emit('submit', $data)"
      >
        Применить
      </button>
    </div>
  </div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'RowSectionForm',
		inject: {
			options: 'options',
		},
		components: {
			Select,
		},
		props: {
			data: Object,
		},
		data() {
			return {
				capacity: 300,
				height: 2000,
				depth: 400,
				width: 1000,
				count: 3,
				...this.data,
			};
		},
	}
</script>

<style scoped>
	.rowSectionForm {
		display: flex;
		flex-direction: column;
	}
	.rowSectionForm-submit {
		padding: 16px;
		width: 146px;
		max-width: 100%;
	}
	.rowSectionForm-params {
		margin: 0;
		padding: 0;
		list-style: none;
    font-size: 14px;
    color: #A7A7A7;
	}
	.rowSectionForm-params > li {
		margin-bottom: 8px;
	}
	.rowSectionForm-fieldset {
		margin: auto 0;
	}
	.rowSectionForm-field {
		margin: 22px 0 30px;
	}
	select {
		margin-top: 10px;
		width: 100%;
	}
</style>
